import { useMemo } from 'react';

import { useStudentView } from '@/features/studentView/StudentViewProvider';

import {
  revealTimelineVisibility,
  useComponentTimeline,
  type ComponentTimelineSource,
} from './useComponentTimeline';

/**
 * The chapter's timeline as its reader goes by it. Student view can reveal
 * content that visibility settings hide from students: a display-only transform
 * of the timeline (the real one drives the banner's "some content is hidden"
 * detection; no setting is ever changed).
 */
export function useReaderTimeline(source: ComponentTimelineSource) {
  const studentView = useStudentView();
  const realTimeline = useComponentTimeline(source);
  const revealHiddenContent = studentView.active && studentView.showHiddenContent;
  const timeline = useMemo(
    () => (revealHiddenContent ? revealTimelineVisibility(realTimeline) : realTimeline),
    [realTimeline, revealHiddenContent],
  );

  return { realTimeline, timeline };
}
